import React, { Component } from 'react';
import { connect } from 'react-redux';
import axiosInstance from '../../store/services/AxiosService';
import SweetAlert from 'react-bootstrap-sweetalert';

class QuestionWeights extends Component {
    constructor(props) {
        super(props);
        this.state = {
            weights: [],
            loading: true,
            saving: false,
            alert: null
        };
    }

    componentDidMount() {
        this.fetchWeights();
    }

    fetchWeights = () => {
        const schoolId = this.props.dataSchool.value;
        axiosInstance.get(`/question-weights/school/${schoolId}`)
            .then(res => {
                const weightsData = res.data && res.data.data ? res.data.data : (Array.isArray(res.data) ? res.data : []);
                this.setState({ weights: weightsData, loading: false });
            })
            .catch(err => {
                console.error(err);
                this.setState({ loading: false, weights: [] });
            });
    }

    handleWeightChange = (index, value) => {
        const newWeights = [...this.state.weights];
        newWeights[index].weight = parseInt(value) || 0;
        this.setState({ weights: newWeights });
    }

    saveWeights = () => {
        this.setState({ saving: true });
        const schoolId = this.props.dataSchool.value;
        axiosInstance.post(`/question-weights/school/${schoolId}`, {
            weights: this.state.weights
        })
            .then(res => {
                this.setState({
                    saving: false,
                    alert: <SweetAlert success title="Sukses" onConfirm={() => this.setState({ alert: null })}>
                        Bobot soal berhasil disimpan!
                    </SweetAlert>
                });
            })
            .catch(err => {
                console.error(err);
                this.setState({
                    saving: false,
                    alert: <SweetAlert danger title="Gagal" onConfirm={() => this.setState({ alert: null })}>
                        Gagal menyimpan bobot soal.
                    </SweetAlert>
                });
            });
    }

    render() {
        return (
            <div className="content-wrapper p-4 pt-5 pb-5">
                {this.state.alert}
                <div className="card shadow mb-4">
                    <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 className="m-0 font-weight-bold text-primary" style={{ fontSize: '20px' }}>Pengaturan Bobot Tipe Soal (Global)</h6>
                    </div>
                    <div className="card-body">
                        {this.state.loading ? (
                            <div>Loading...</div>
                        ) : (
                            <div>
                                <table className="table table-bordered">
                                    <thead className="bg-light">
                                        <tr>
                                            <th>Tipe Soal</th>
                                            <th style={{ width: '150px' }}>Bobot Poin</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.weights.map((w, i) => (
                                            <tr key={i}>
                                                <td style={{ textTransform: 'capitalize' }}>{w.type_name}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={w.weight}
                                                        min="1"
                                                        onChange={(e) => this.handleWeightChange(i, e.target.value)}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="mt-3 text-right">
                                    <button 
                                        className="btn btn-primary" 
                                        onClick={this.saveWeights} 
                                        disabled={this.state.saving}
                                    >
                                        {this.state.saving ? 'Menyimpan...' : 'Simpan Pengaturan'}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    dataSchool: state.User.dataSchool,
});

export default connect(mapStateToProps)(QuestionWeights);
